/**
 * `POST /user/reactions/toggle` only ever returns `{ record }` — never an
 * updated reactions aggregate (see `api/app/controllers/user/reactions_controller.rb`).
 * Trust the server count when it's actually present; otherwise keep the
 * client's own optimistic count instead of falling back to stale pre-toggle data.
 */
export const resolveReactionCount = (
  optimisticCount: number,
  serverReactions?: Record<string, number> | null
): number => serverReactions?.like ?? optimisticCount
